<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: calc(100% - 20px);margin: 0 20px;padding-top: 20px">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;">
          <div style="height: 50px">
            <el-input prefix-icon="el-icon-search" placeholder="输入搜索组织" v-model="filterText" clearable></el-input>
          </div>
          <div style="height: calc(100% - 50px);overflow: auto">
            <el-tree highlight-current default-expand-all :data="treeData" :props="defaultProps" disabled :current-node-key="currentId" node-key="showId"
                     :filter-node-method="filterNode" ref="treeData">
              <div style="width: 100%" class="custom-tree-node" slot-scope="{ node, data }">
                <div v-if="data.type === 'org'" style="width: 100%">
                  <i class="el-icon-s-flag" v-if="data.org_type === 0"></i>
                  <i class="el-icon-office-building" v-if="data.org_type === 1"></i>
                  <i class="el-icon-menu" v-if="data.org_type === 2"></i>
                  <span :title="data.name">{{ data.name }}</span>
                  <!--      <span style="font-size: 12px"> {{ data.name }}</span>-->
                </div>
                <div v-else style="width: 100%">
                  <el-row style="width: 100%">
                    <el-col :span="16">
                      <i class="el-icon-video-camera"></i>
                      <span>{{ data.name }}</span>
                    </el-col>
                    <el-col :span="8" style="text-align: right">
                      <i title="监控" class="el-icon-view" style="cursor: pointer; font-size: 18px;color: blue" @click="viewOpen(data)"></i>
                      <!--                      <img title="监控" src="../../assets/see.png" style="cursor: pointer;width: 16px" @click="viewOpen(data)">-->
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="20" style="height: 100%">
          <div class="right-content">
            <div style="height: 52px;">
              <el-select v-fixZoom v-model="status" placeholder="请选择" style="width: 100px;" @change="changeShow">
                <el-option v-for="item in statusArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
<!--              <img @click="fullScan" style="vertical-align: bottom;cursor: pointer" src="../../assets/icon/full_screen.png">-->
<!--              <el-select v-fixZoom class="input-query" v-model="objectFit" style="width: 100px;float: right" @change="changeObjectFit">-->
<!--                <el-option v-for="item in objectFitArr" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--              </el-select>-->
            </div>
            <div id="full" class="right-div">
              <div :style="getWidthHeight(status)" class="video-item" v-for="item in videoList" :key="item.index">
                <div v-if="item.isVideo" style="padding-top: 2%;width: 96%;height: 96%">
                  <div class="video-item-title">
                    <div class="video-item-title-text">{{item.name}}</div>
                    <div class="video-item-title-close" @click="closeView(item)">x</div>
                  </div>
                  <div style="width: 100%;height: calc(100% - 25px)">
                    <video-component :ref="'videoComponent' + item.id"></video-component>
                  </div>
<!--                  <vue-srs :id="'vueSrs' + item.id" :ref="'vueSrs' + item.id" :key="item.index" style="height: calc(100% - 25px);width: 100%"></vue-srs>-->
                </div>
                <!--            <img v-else src="../../assets/icon/video_bg.png">-->
                <img v-else src="../../assets/lookVedioBG.png" style="object-fit: fill">
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import {queryentity} from '../../api/yanglaoyuan'
import videoComponent from '../videoComponent'
import {getUsername} from '../../utils/auth'

export default {
  name: 'videoMonitor',
  components: {videoComponent},
  data () {
    return {
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      currentId: '',

      status: 4,
      statusArr: [
        {name: 1, id: 1},
        {name: 4, id: 4},
        {name: 9, id: 9},
        {name: 16, id: 16}
      ],
      videoList: [
        {id: 1, name: '', isVideo: false}, {id: 2, name: '', isVideo: false},
        {id: 3, name: '', isVideo: false}, {is: 4, name: '', isVideo: false}
      ],

      orgArr: [],
      videoArr: []
    }
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  created () {
    let host = window.location.host
    let userName = getUsername()
    if ((host === 'jiaold.com' || host === 'localhost:8080') && userName === '养老院管理员') {
      this.videoArr = [
        {type: 'video', videoType: 'ysy', id: 1, pid: 1326, name: 'wifi美兰前台', seriesNo: 'D44340961', url: 'ezopen://open.ys7.com/D44340961/1.live', accessToken: 'at.0ck5ytja5cr5uo9a1el29jet85r2u22i-4n79tbf6et-1hjr6ls-pobhlbpyv'},
        {type: 'video', videoType: 'ysy', id: 2, pid: 1340, name: '二楼楼梯', seriesNo: 'G92343972', url: 'ezopen://open.ys7.com/G92343972/1.live', accessToken: 'at.b891dpyrazpjos6e7dh6nkva5b152kfd-26l1k9qk86-09yyow1-ghtjnkrrh'},
        {type: 'video', videoType: 'ysy', id: 3, pid: 1344, name: '三楼梯', seriesNo: 'G93597023', url: 'ezopen://open.ys7.com/G93597023/1.live', accessToken: 'at.b891dpyrazpjos6e7dh6nkva5b152kfd-26l1k9qk86-09yyow1-ghtjnkrrh'},
        {type: 'video', videoType: 'ysy', id: 4, pid: 1342, name: '二楼仓库', seriesNo: 'J33803975', url: 'ezopen://open.ys7.com/J33803975/1.live', accessToken: 'at.b891dpyrazpjos6e7dh6nkva5b152kfd-26l1k9qk86-09yyow1-ghtjnkrrh'},
        {type: 'video', videoType: 'ysy', id: 5, pid: 1343, name: '后院', seriesNo: 'L38584350', url: 'ezopen://open.ys7.com/L38584350/1.live', accessToken: 'at.b891dpyrazpjos6e7dh6nkva5b152kfd-26l1k9qk86-09yyow1-ghtjnkrrh'},
        {type: 'video', videoType: 'ysy', id: 5, pid: 1345, name: '前门', seriesNo: 'K79425547', url: 'ezopen://open.ys7.com/K79425547/1.live', accessToken: 'at.b891dpyrazpjos6e7dh6nkva5b152kfd-26l1k9qk86-09yyow1-ghtjnkrrh'}
      ]
    }
    this.getOrgData()
  },
  beforeDestroy () {
    this.videoList.filter(async value => {
      if (value.isVideo) {
        await this.closeView(value)
      }
    })
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    viewOpen (data) {
      let that = this
      let isContains = false
      // 判断设备是否正在通话（防止多次点击）
      that.videoList.forEach(function (item) {
        if (item.isVideo && item.name.indexOf(data.name) !== -1) {
          isContains = true
        }
      })
      if (!isContains) {
        let isFull = true
        // 判断还有没有多余的可播放组件
        for (let i = 0; i < that.videoList.length; i++) {
          if (!that.videoList[i].isVideo) {
            isFull = false
            that.startVideo(data, that.videoList[i])
            break
          }
        }
        if (isFull) {
          this.$message({
            message: '可播放容器已满',
            type: 'warning'
          })
        }
      }
    },
    async closeView (videoListItem) {
      // let that = this
      if (videoListItem.isVideo) {
        let videoComponent = this.$refs['videoComponent' + videoListItem.id]
        if (videoComponent) {
          await videoComponent[0].closeVideo()
        }
        videoListItem.name = ''
        videoListItem.isVideo = false
        videoListItem.videoRow = null
      }
    },

    startVideo (videoObj, videoListItem) {
      let that = this
      videoListItem.name = videoObj.name
      videoListItem.isVideo = true
      setTimeout(() => {
        // vm.$refs.vueSrs1[0].openVideo(videoRow)
        let videoComponent = that.$refs['videoComponent' + videoListItem.id]
        if (videoComponent) {
          videoComponent[0].startVideo(videoObj)
        }
      }, 50)
    },

    async changeShow () {
      await this.videoList.filter(async value => {
        if (value.isVideo) {
          await this.closeView(value)
        }
      })

      if (this.status === 1) {
        this.videoList = [{id: 1, name: 1, isVideo: false, videoRow: null}]
      } else if (this.status === 4) {
        this.videoList = [
          {id: 1, name: 1, isVideo: false, videoRow: null}, {id: 2, name: 1, isVideo: false, videoRow: null},
          {id: 3, name: 1, isVideo: false, videoRow: null}, {is: 4, name: 1, isVideo: false, videoRow: null}
        ]
      } else if (this.status === 9) {
        this.videoList = [
          {id: 1, name: 1, isVideo: false, videoRow: null}, {id: 2, name: 1, isVideo: false, videoRow: null},
          {id: 3, name: 1, isVideo: false, videoRow: null}, {is: 4, name: 1, isVideo: false, videoRow: null},
          {id: 5, name: 1, isVideo: false, videoRow: null}, {id: 6, name: 1, isVideo: false, videoRow: null},
          {id: 7, name: 1, isVideo: false, videoRow: null}, {id: 8, name: 1, isVideo: false, videoRow: null},
          {id: 9, name: 1, isVideo: false, videoRow: null}
        ]
      } else if (this.status === 16) {
        this.videoList = [
          {id: 1, name: 1, isVideo: false, videoRow: null}, {id: 2, name: 1, isVideo: false, videoRow: null},
          {id: 3, name: 1, isVideo: false, videoRow: null}, {id: 4, name: 1, isVideo: false, videoRow: null},
          {id: 5, name: 1, isVideo: false, videoRow: null}, {id: 6, name: 1, isVideo: false, videoRow: null},
          {id: 7, name: 1, isVideo: false, videoRow: null}, {id: 8, name: 1, isVideo: false, videoRow: null},
          {id: 9, name: 1, isVideo: false, videoRow: null}, {id: 10, name: 1, isVideo: false, videoRow: null},
          {id: 11, name: 1, isVideo: false, videoRow: null}, {id: 12, name: 1, isVideo: false, videoRow: null},
          {id: 13, name: 1, isVideo: false, videoRow: null}, {id: 14, name: 1, isVideo: false, videoRow: null},
          {id: 15, name: 1, isVideo: false, videoRow: null}, {id: 16, name: 1, isVideo: false, videoRow: null}
        ]
      }
    },
    getWidthHeight (val) {
      // console.log(val)
      if (val === 1) {
        return {width: '100%', height: '100%'}
      } else if (val === 4) {
        return {width: '50%', height: '50%'}
      } else if (val === 9) {
        return {width: '33%', height: '33%'}
      } else if (val === 16) {
        return {width: '25%', height: '25%'}
      }
    },

    getOrgData () {
      queryorg().then(async res => {
        this.orgArr = res.data.org
        await this.orgArr.filter(org => {
          org.type = 'org'
        })
        this.getEntity()
      }).catch(() => {})
    },
    getEntity () {
      let orgEntity = this.orgArr.filter(r => r.entity_id !== '' && r.entity_id !== 0)
      if (orgEntity) {
        orgEntity.forEach(async obj => {
          let body = {
            oid: obj.id
          }
          await queryentity(body).then(res => {
            let entityArr = res.data.entity
            let entity = entityArr.find(r => r.id === obj.entity_id)
            if (entity) {
              obj.name += ' / ' + entity.entity_name
            }
          }).catch(() => {})
        })
        this.getOrgTree()
      }
    },
    getOrgTree () {
      let that = this
      this.treeData = []
      let minLevel = Math.min.apply(Math, this.orgArr.map(function (org) {
        return org.level
      }))
      this.orgArr.filter(org => {
        if (org.level === minLevel) {
          that.treeData.push(org)
        }
      })
      for (let i = 0; i < this.treeData.length; i++) {
        const child = this.arrayToNode(this.orgArr, this.treeData[i].id)
        if (child.length !== 0) {
          this.treeData[i].child = child
        }
      }
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          if (value.org_type === 2) {
            value.child = vm.videoArr.filter(r => r.pid === value.id)
          }
          return value
        }
      })
    }
  }
}
</script>

<style scoped>
.right-content {
  margin-left: 25px;
  height: 100%;
  width: calc(100% - 25px);
}
.right-div{
  height: calc(100% - 60px);
  width: 100%;
}
.video-item{
  float: left;
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-around;*/
  /*flex-wrap: wrap;*/
  /*overflow: auto;*/
}
.video-item img {
  padding-top: 2%;
  width: 96%;
  height: 96%;
  margin: auto;
  /*box-sizing: border-box;*/
  /*padding: 40px 84px;*/
  /*border-radius: 5px;*/
  /*border: 2px solid #06EEF7;*/
}
.video-item-title{
  display: flex;
  width: 100%;
  height: 15px;
  line-height: 15px;
  padding: 5px 0 5px 0;
}
.video-item-title-text{
  width: 100%;
  color: #000000;
  text-align: center;
}
.video-item-title-close{
  /*position: absolute;*/
  /*top: 2px;*/
  right: 10px;
  z-index: 999;
  cursor: pointer;
  color: red;
  width: 10px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/videoMonitor.vue